import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  selectedFolder: "" as any,
};

const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    // Previous setSelectedFolder(payload) stored payload directly.
    setSelectedFolder: (state, action: PayloadAction<any>) => {
      state.selectedFolder = action.payload;
    },
  },
});

export const { setSelectedFolder } = documentsSlice.actions;

export default documentsSlice.reducer;
